import { css } from '@emotion/core';
import { rgba, tokens, globalTokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var navigationButton = {
  name: "c4cke9",
  styles: "height:100%;width:100px;display:flex;flex-direction:row;align-items:center;justify-content:center;position:absolute;top:0;bottom:0;"
};
export var left = {
  name: "260zpl",
  styles: "left:0;"
};
export var right = {
  name: "19zs6va",
  styles: "right:0;"
};
export var button = /*#__PURE__*/css("display:inline-block;background-color:", rgba(globalTokens.colors.black, 0.1), ";color:", colors.neutral.subdued.default, ";border:2px solid ", colors.neutral.subdued.default, ";border-radius:100px;width:56px;height:56px;outline:none;cursor:pointer;&:hover{background-color:", rgba(globalTokens.colors.white, 0.1), ";}");
export var show = {
  name: "qxhst0",
  styles: "visibility:visible;opacity:1;transition:opacity 0.5s linear;"
};
export var hide = {
  name: "nhfyzs",
  styles: "visibility:hidden;opacity:0;transition:visibility 0s 0.5s,opacity 0.5s linear;"
};